<template>
  <div class="app-container">
        <!-- (乐山杜一生商户号：1737559001   乐山益肤源商户号：1105338659) -->
    <el-card class="box-card" v-if="rowItem&&rowItem.id>0">
      <div class="city-company-info">
        <h3>城市公司信息</h3> 
         <el-descriptions :column="2" border>
          <el-descriptions-item label="账套ID">{{ rowItem.id }}</el-descriptions-item>
          <el-descriptions-item label="城市公司ID">{{ rowItem.cityCompanyListVO?rowItem.cityCompanyListVO[0].id:"-" }}</el-descriptions-item>
          <el-descriptions-item label="城市公司名称">{{ getCityCompanyName() }}</el-descriptions-item> 
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-if="channelType==='allinpay'">新增</el-button>
          <el-button type="primary" size="mini" @click="handleExport" plain :loading="exportLoading">导出</el-button>
          <el-button type="primary" size="mini" @click="handleDownTemplate" plain>下载导入模板</el-button>
          <!-- 走 http-request 自己发请求，不用 el-upload 默认的 action，
               这样能带上登录态、也能拿到后端返回的导入结果明细 -->
          <el-upload style="display:inline-block;margin:0 8px" action="#" :show-file-list="false"
            :http-request="handleImport" accept=".xlsx,.xls">
            <el-button type="primary" size="mini" plain :loading="importLoading">批量导入</el-button>
          </el-upload>
          <el-button type="info" @click="handleBack" plain size="mini">返回上一页</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="渠道类型" prop="channelType" align="center" width="120">
          <template slot-scope="{row}">
            <span v-if="row.channelType === 'allinpay'">银行卡支付</span>
            <span v-else-if="row.channelType === 'wechat'">微信支付</span>
            <span v-else>{{ row.channelType || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商户号所属城市公司" prop="cityCompanyName" align="center"  />
        <el-table-column label="商户号" prop="merchantId" align="center"  />
        <el-table-column label="关联城市" prop="cityCompanyId" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ getCityName(row)}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="商户序列号" prop="merchantSerialNumber" align="center" />
        <el-table-column label="应用ID" prop="appId" align="center" />
        <el-table-column label="公钥ID" prop="publicKeyId" align="center" show-overflow-tooltip />
        <el-table-column label="公钥" prop="publicKey" align="center" show-overflow-tooltip />
        <el-table-column label="私钥" prop="privateKey" align="center" show-overflow-tooltip /> -->
        <el-table-column label="API V3密钥" prop="apiV3Key" align="center" show-overflow-tooltip />
        <el-table-column label="状态" prop="isEnable" align="center" width="100">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="当日金额" prop="currentDayAmount" align="center" width="120">
          <template slot-scope="{row}">
            {{ row.currentDayAmount || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="当月金额" prop="currentMonthAmount" align="center" width="120">
          <template slot-scope="{row}">
            {{ row.currentMonthAmount || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="最后订单时间" prop="lastOrderTime" align="center" width="160">
          <template slot-scope="{row}">
            {{ row.lastOrderTime|formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" align="center" width="160" />
        <el-table-column label="操作" align="center" fixed="right" width="100">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    
    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑商户信息' : '新增商户信息'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="渠道类型" prop="channelType">
          <el-select v-model="form.channelType" placeholder="请选择渠道类型" style="width: 100%">
            <el-option label="银行卡支付" value="allinpay"></el-option>
            <el-option label="微信支付" value="wechat"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户号所属城市公司" prop="cityCompanyId">
          <el-select v-model="form.cityCompanyId" placeholder="请选择城市公司" style="width: 100%" filterable>
            <el-option 
              v-for="item in cityCompanyOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户号" prop="merchantId">
          <el-input v-model="form.merchantId" placeholder="请输入商户号" />
        </el-form-item>
        <el-form-item label="可使用城市公司" prop="cityCompanyIds">
          <el-select v-model="form.cityCompanyIds" placeholder="请选择城市公司" style="width: 100%" filterable multiple collapse-tags>
            <el-option 
              v-for="item in cityCompanyOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="关联城市" prop="cityCompanyId">
          <el-select v-model="form.cityCompanyId" placeholder="请选择关联城市" style="width: 100%" filterable>
            <el-option 
              v-for="item in cityCompanyOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商户序列号(微信支付必填)" prop="merchantSerialNumber" v-if="form.channelType==='wechat'">
          <el-input v-model="form.merchantSerialNumber" placeholder="请输入商户序列号" />
        </el-form-item>
        <el-form-item label="应用ID" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入应用ID" />
        </el-form-item>
        <el-form-item label="组织ID(通联支付必填)" prop="organizationId" v-if="form.channelType==='allinpay'">
          <el-input v-model="form.organizationId" placeholder="请输入组织ID" />
        </el-form-item>
        <el-form-item label="公钥ID((微信支付必填))" prop="publicKeyId" v-if="form.channelType==='wechat'">
          <el-input v-model="form.publicKeyId" placeholder="请输入公钥ID" />
        </el-form-item>
        <el-form-item label="公钥" prop="publicKey" class="width100">
          <el-input v-model="form.publicKey" type="textarea" :rows="3" placeholder="请输入公钥" />
        </el-form-item>
        <el-form-item label="私钥" prop="privateKey" class="width100">
          <el-input v-model="form.privateKey" type="textarea" :rows="3" placeholder="请输入私钥" />
        </el-form-item>
        <el-form-item label="API V3密钥" prop="apiV3Key" class="width100">
          <el-input v-model="form.apiV3Key" type="textarea" :rows="3" placeholder="请输入API V3密钥" />
        </el-form-item>
        <el-form-item label="状态" prop="isEnable">
          <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="doSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 导入结果弹窗已提成共用组件（REQ-2026-751517 返工），账套列表页的全量导入也用它 -->
    <import-result-dialog ref="importResultDialog" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import cityCompanyApi from '@/api/sys/cityCompany'
import payMerchantApi from '@/api/config/payMerchant'
import importResultDialog from './importResultDialog.vue'
import { formatDate } from '@/utils/dateTime'

function initFormBean() {
  return {
    id: null,
    apiV3Key: 'F1F082628757D4F959AE4A33F5C5D8E7',
    appId: '00389501',
    channelType: '',
    cityCompanyId: null,
    cityCompanyIds: [],
    isEnable: false,
    merchantId: '270191053114039',
    merchantSerialNumber: '',
    organizationId: '56466707399N02M',
    privateKey: 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDkKkb2f//GzRQk9rJljH1SU9Kp8px20yyJIIz5FXpuHtbhnA+KhKbw9Il4XRNplLmYqyL+HxuuX3/kw4q/qJeJhT307QKWQARtQarefV9hiQdgspm7HXqjk6TnKguDTQArbticbRnt/MYuyIMXV0DOkbnJOcWP/Hn1b/cAjNMyTKn5Zdf9vTvPw9anXflTBOGdd46WPqJ9M6kwD8VjWQ/ZqymZfhtceB4JA+vSC/Lp4XgLB8sxrl8g7wzpvsK4VRlptZj3ULk6QJOaHNaLLc/gQPw409GlLTfpZC+Ufy4XjQB5C28/ZSEQeZUtP8t0EQS4hvNHA9lFL2TMVZTLjGTpAgMBAAECggEAHZ0HHNM8JVdUt/905A057seGXhxpBlseOqYI5gNNoqFKDnos4jOZX0i91uttq5RsCk6b+hObiiRG+zAOABYnpOewROvGHC4u5OdTABGRoZ0hYgGMRmbrFfQBwScJ237Q+NIoNxVJ+kOGjWfk69CdTrJHRMDEzY1dXuerTVz5xFtELY8MYW6zFj/UTel03ZFSPtV+yFDlua90LTo05Tx8wchS6rxZwMxWhS5pTdKrY5h1LLr6aj5koOdd6xBHCIfZF3UVjZ283Vkj6VKHtW26sCJEu7d3/isY1eBFm0TKYTEMNMLGfO5msqDHnGGTjN79snza++7RYwmEKblK37JD6QKBgQD1zgMmB9Sh1M/+uo8XFu9FBKWZwo3lya5oyS4MfP+ch/rcDVPTomCjyhK9dJETY1mjy92bQjMLkcs6CcYsNLT7qzcGab6ZS6BaZC34DnGA5jz/NHxiZgqstOYE5kOZ/gukp5ZeQfwCkCNwuSQKBOGIzsS2AAk9847H/oNDn9jwmwKBgQDtoPch55xC6bW1M5ohpagv0un8Ha1ODKFtC2CLeJOJZtgRvoIln4s/sVcxfPYr9l+Y3GJAod5wDS8OF3aCJQk5ZL3daWqQR4fOtzbEudkjKQ68nHFTgjeUvxVi+YWgUb4cgEmwoUnzT+WihcT1qw+f+/sEXw/gEDsXYSE2PBluywKBgBmVQISjygCx6pgDiMMJcwvG6Qlw0134OLvVPIK2O9Bp4rUmefQL8Wz6qiqnyDWxYHII1N7E7BUnLnSy8bpGHhQXhNmZBepkkaL2zEYGEtAspmqVZuDC6BeDmHEoGh8b7tBLVP4odfc6U0X3LwYP7f1UL+sVY+DbyZ+NINJX/7dDAoGATWe1mNG9UP6YNiJM/tDbbFij54AzR81NeBvQox3v0T4y+/S2qFLEJUc7Q9+UwNVMZprDVpJjxtREk66I5/PwgUWTo2AHWmAymN+Nc5+mX5GsPzwmnjE4sbdc3BSztnlqGBah6mtfj2ZjQwGYGv5R5KdMKSxeG3quBPuaufPxxOkCgYEA18VLI0lxZjdjxCvTRkQSoXfYF0KoQsOrI9ElLhAejNEMHyNzyAgkvuPCgOP2EXwi87LTooiy+1h3IV5cQ5yIozdyUQV96gmfwpP9D7aMqaZPpQI9+Ub7NIVqVs4oGPZvK+1QUjqrFuazRAPM2gTajz3Uhvvi2iICbeCfI8hOzLM=',
    publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCm9OV6zH5DYH/ZnAVYHscEELdCNfNTHGuBv1nYYEY9FrOzE0/4kLl9f7Y9dkWHlc2ocDwbrFSm0Vqz0q2rJPxXUYBCQl5yW3jzuKSXif7q1yOwkFVtJXvuhf5WRy+1X5FOFoMvS7538No0RpnLzmNi3ktmiqmhpcY/1pmt20FHQQIDAQAB',
    publicKeyId: ''
  }
}

export default {
  props: {
    rowItem: {
      type: Object,
      default: () => ({})
    },
    channelType: {
      type: String,
      default: ''
    }
  },
  components: {
    importResultDialog,
    Pagination
  },
  filters: {
    formatDate
  },
  data() {
    return {
      list: [],
      originalList: [], // 原始数据列表
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        channelType: '', // 渠道类型：allinpay|通联支付，wechat|微信支付
        state: 1, // 默认启用
        cusId: '', // 商户号
      },
      selectItems: [],
      cityCompanyOptions: [],
      exportLoading: false,
      importLoading: false,
      formVisible: false,
      form: initFormBean(),
      formRules: {
        channelType: [{ required: true, message: '请选择渠道类型', trigger: 'change' }],
        merchantId: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
        cityCompanyId: [{ required: true, message: '请选择关联城市', trigger: 'change' }]
      }
    }
  },
  watch: {
    // 监听 channelType prop 的变化
    channelType: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.query.channelType = newVal
          // 如果组件已创建，则重新查询
          if (this._isMounted) {
            this.doQueryList({ pageNo: 1 })
          }
        }
      }
    }
  },
  created() {
    // 如果传入了 channelType，则设置到查询条件中
    if (this.channelType) {
      this.query.channelType = this.channelType
    }
    this.getCityCompany()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /** 导出：带当前筛选条件，后端不分页导全量 */
    handleExport() {
      this.exportLoading = true
      const { pageNo, pageSize, ...params } = this.query
      payMerchantApi.exportExcel(params).finally(() => {
        this.exportLoading = false
      })
    },
    handleDownTemplate() {
      payMerchantApi.downloadTemplate()
    },
    /**
     * 批量导入。后端逐行处理，合法的落库、非法的只记原因，
     * 所以这里不能只看有没有报错，必须把结果明细摊给运营看。
     */
    handleImport(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.importLoading = true
      payMerchantApi.importExcel(formData).then(({ data }) => {
        this.$refs.importResultDialog.show(data)
        if (data && data.failCount > 0) {
          this.$message.warning(`导入完成，有 ${data.failCount} 行未导入`)
        } else {
          this.$message.success('导入完成')
        }
        this.doQueryList({})
      }).finally(() => {
        this.importLoading = false
      })
    },
   
    // 获取城市公司名称
    getCityCompanyName() {
      console.log('传过来的数据',this.rowItem)
      if (!this.rowItem || !this.rowItem.cityCompanyListVO || !this.rowItem.cityCompanyListVO.length) {
        return '-'
      }
      return this.rowItem.cityCompanyListVO[0].name || '-'
    },
    //得到城市公司的名字
    getCityName(row){
      if(row.channelType==='wechat'){
        // if(row.merchantId==='1737559001'){
        //   return '乐山杜一生'
        // }else if(row.merchantId==='1105338659'){
        //   return '乐山益肤源'
        // }
        return '全平台轮训使用'
      }else if(row.channelType==='allinpay'){
        if(row.cityCompanys && typeof row.cityCompanys === 'object'){
          // 将对象格式化为 "ID-名字, ID-名字" 的格式
          return Object.keys(row.cityCompanys)
            .map(key => `${key}-${row.cityCompanys[key]}`)
            .join(', ')
        }
        return row.cityCompanys || '-'
      }
      return '-'

    },
    getCityCompany() {
      cityCompanyApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(res => {
        this.cityCompanyOptions = res.data.list
      })
    },
    handleFilter() {
      this.query.pageNo = 1
      // 重置时，如果有初始传入的 channelType，则恢复初始值，否则清空
      this.query.channelType = this.channelType || ''
      this.query.state = 1
      this.query.cusId = ''
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        // 'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      this.listLoading = true
      // 构建查询参数
      const params = {
        pageNo: pageNo || this.query.pageNo,
        pageSize: pageSize || this.query.pageSize,
      }
      // 添加可选参数
      if (this.query.channelType) {
        params.channelType = this.query.channelType
      }
      if (this.query.state !== null && this.query.state !== undefined) {
        params.state = this.query.state
      }
      if (this.query.cusId) {
        params.cusId = this.query.cusId
      }
      // BUG-2026-447195：按账套行进来时，按该账套绑定的城市公司筛选商户号。
      // 原来①只在 allinpay 传，微信直连配置入口永远不筛；②传的是 rowItem.id（账套 ID），不是城市公司 ID，
      // 城市公司在 rowItem.cityCompanyListVO[0].id（本文件第 9 行显示用的就是它）。
      // 工具栏「银行卡配置」入口 rowItem 为空，仍是全量，行为不变。
      const cityCompanyId = this.rowItem && this.rowItem.cityCompanyListVO && this.rowItem.cityCompanyListVO.length
        ? this.rowItem.cityCompanyListVO[0].id : null
      if (cityCompanyId) {
        params.cityCompanyId = cityCompanyId
      }
      return payMerchantApi.fetchList(params)
        .then(res => {
          // 处理后端返回的分页数据结构
          if (res.data && res.data.list) {
            this.originalList = res.data.list || []
            this.list = res.data.list || []
            this.total = res.data.total || 0
            // 更新分页信息
            if (res.data.currentPage) {
              this.query.pageNo = res.data.currentPage
            }
            if (res.data.pageSize) {
              this.query.pageSize = res.data.pageSize
            }
          } else {
            // 兼容旧的数据结构
            this.originalList = res.data || []
            this.list = res.data || []
          }
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      payMerchantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.form = initFormBean()
      // 如果有传入的 channelType，设置默认值
      if (this.channelType) {
        this.form.channelType = this.channelType
      }
      this.formVisible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate()
        }
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      // 处理城市公司ID集合：如果是字符串（逗号隔开），转换为数组；如果是数组，直接使用；否则为空数组
      let cityCompanyIds = []
      if (row.cityCompanyIds) {
        if (typeof row.cityCompanyIds === 'string') {
          cityCompanyIds = row.cityCompanyIds.split(',').filter(id => id).map(id => Number(id.trim()))
        } else if (Array.isArray(row.cityCompanyIds)) {
          cityCompanyIds = row.cityCompanyIds
        }
      }
      
      // 处理城市公司ID：确保转换为数字类型，以便el-select能正确匹配并显示名称
      let cityCompanyId = null
      if (row.cityCompanyId !== null && row.cityCompanyId !== undefined && row.cityCompanyId !== '') {
        cityCompanyId = Number(row.cityCompanyId)
      }
      
      this.form = {
        id: row.id,
        apiV3Key: row.apiV3Key || '',
        appId: row.appId || '',
        channelType: row.channelType || '',
        cityCompanyId: cityCompanyId,
        cityCompanyIds: cityCompanyIds,
        isEnable: row.isEnable !== undefined ? row.isEnable : false,
        merchantId: row.merchantId || '',
        merchantSerialNumber: row.merchantSerialNumber || '',
        organizationId: row.organizationId || '',
        privateKey: row.privateKey || '',
        publicKey: row.publicKey || '',
        publicKeyId: row.publicKeyId || ''
      }
      this.formVisible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate()
        }
      })
    },
    /**
     * 取消表单
     */
    handleCancel() {
      this.formVisible = false
      this.form = initFormBean()
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
    },
    /**
     * 提交表单
     */
    doSubmit() {
     
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.form))
          // if (this.rowItem && this.rowItem.id) {
          //     params.cityCompanyId = Number(this.rowItem.id)
          //   }
          // 将城市公司ID数组转换为逗号隔开的字符串
          if (params.cityCompanyIds && Array.isArray(params.cityCompanyIds) && params.cityCompanyIds.length > 0) {
            params.cityCompanyIds = params.cityCompanyIds.join(',')
          } else {
            params.cityCompanyIds = ''
          }
          if (this.form.id) {
            // 编辑 - 使用 PUT 请求
            payMerchantApi.update(params).then(() => {
              this.$common.showMsg('success', '更新成功')
              this.handleCancel()
              this.doQueryList({})
            }).catch(() => {
              // 错误已在 API 拦截器中处理
            })
          } else {
            delete params.id
            // 新增 - 使用 POST 请求
            payMerchantApi.create(params).then(() => {
              this.$common.showMsg('success', '新增成功')
              this.handleCancel()
              this.doQueryList({ pageNo: 1 })
            }).catch(() => {
              // 错误已在 API 拦截器中处理
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.city-company-info {
  h3 {
    margin: 0 0 20px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
  }
}
.is-main-merchant {
  color: #f56c6c;
  font-weight: bold;
}
.filter-container {
  .filter-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    
    .filter-item {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      
      .filter-label {
        margin-right: 8px;
        white-space: nowrap;
      }
    }
    
    .reset-btn {
      margin-left: 0;
    }
  }
}
.form-container {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    
    h3 {
      margin: 0;
      color: #303133;
      font-size: 16px;
      font-weight: 600;
    }
  }
  
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
    margin-right: 2%;
    
    &.width100 {
      width: 100%;
      margin-right: 0;
    }
  }
}
</style>
